import isNull from 'lodash/isNull';

import { get } from '../../Common/utils';

import { dropDownDefault } from './constants';

const normalizeAggregators = (aggregators = []) =>
  dropDownDefault.concat(
    aggregators.map(aggregator => ({
      label: get(aggregator, 'aggregatorID', ''),
      value: get(aggregator, 'aggregatorID', ''),
    })),
  );

const normalizePayers = (payers = []) =>
  dropDownDefault.concat(
    payers.map(payer => {
      const id = get(payer, 'payerID', '');

      return {
        label: id ? `${get(payer, 'payerName', '')} (${id})` : '',
        value: id,
      };
    }),
  );

const checkNull = (value, defaultValue) => (isNull(value) ? defaultValue : value);

const normalizeTasks = (list = []) => {
  const taskList = [];

  for (let i = 0; i < list.length; i += 1) {
    const { procedureCode, tasks } = list[i];
    for (let j = 0; j < tasks.length; j += 1) {
      taskList.push({
        procedureCode: checkNull(procedureCode, ''),
        taskID: checkNull(tasks[j].taskID, ''),
        taskName: checkNull(tasks[j].taskName, ''),
      });
    }
  }

  return taskList;
};

export { normalizeAggregators, normalizePayers, normalizeTasks };
